import moment from "moment-timezone";
import * as Immutable from "immutable";
import { CsatResultAttributes } from "./types";

export const CSAT_MESSAGE_SHOWN_TYPE = "csat_shown";

export function getTimeStringFromTimestamp(timestamp: number): string {
  return moment.unix(timestamp).format("LTS");
}

export class CsatResult extends Immutable.Record<CsatResultAttributes>({
  style: null,
  score: null,
  surveyType: null,
  feedback: null,
  isPositive: null,
  resolved: null,
  comment: null
}) {}
